module.exports = __webpack_public_path__ + "static/media/opensanshebrew-regular.56118a19.woff";